module.exports = __webpack_public_path__ + "static/img/av4.459bb844.png";